import { FC, useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import { DeleteSharedNotesModal } from "@/components/modal/delete-shared-notes/delete-shared-notes-modal";
import { AddToCollectionModal } from "@/components/modal/add-to-collection/add-to-collection-modal";
import { FadeBottom } from "@/components/horizontal-scroll/FadeBottom";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { HomePageNotesList } from "./components/NotesListPageList";
import { NotesListPageHeader } from "./components/NotesListPageHeader";
import { MdsPanelContainer } from "@/design-system/components/panel";
import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import { Appear } from "@/components/appear";
import styled from "@emotion/styled";
import { NotesPageDragAndDrop } from "@/pages/notes/DragAndDrop";
import { useTabPageStore } from "@/hooks/useTabPageStore";

interface NotesListPageProps {}

export const NotesListPage: FC<NotesListPageProps> = observer(() => {
  const page = useTabPageStore("notesListPage");
  const isEmpty = page.hasNoItems;
  const filters = page.filters;
  page.useEffects();

  const [isDragging, setIsDragging] = useState(false);

  /**
   * Track views of the notes list page.
   */
  useEffect(() => {
    trackEvent(TrackedEvent.NotesView, {
      lens: filters.params.lens,
      sort_by: filters.params.sortBy,
    });
  }, [filters.params.lens, filters.params.sortBy]);

  return (
    <PageWrapper visible={page.subscriptionInitialized}>
      <AddToCollectionModal store={page.addToCollectionModal} />
      <DeleteSharedNotesModal store={page.deleteSharedNotesModal} />
      <ShareSheetModal store={page.shareSheetModal} />
      <NotesListPageHeader />
      <NotesPageDragAndDrop onDrag={setIsDragging} isEmpty={isEmpty}>
        <MdsPanelContainer>
          <HomePageNotesList isDragging={isDragging} />
          <FadeBottom />
        </MdsPanelContainer>
      </NotesPageDragAndDrop>
    </PageWrapper>
  );
});

NotesListPage.displayName = "NotesListPage";

const PageWrapper = styled(Appear)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});
